Vendd.Scripts.load(function () {
    var $wrapper = $('.x-currency-selector');

    $('.js-change-currency', $wrapper).click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        Vendd.Cart.ClearClientModel();

        document.location.href = $(this).attr('href');
    });
});